import React from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import { Button, ClickAwayListener } from '@material-ui/core'

import styles from './help-find-modal.module.scss'
import { useFormikContext } from 'formik'
import { PopupFormDataType } from 'src/features/projects'
import { useTranslation } from '@plandi/common'

type Props = {
  handleCancel: () => void
  initialValues: PopupFormDataType
  title?: string
  text?: string
}

export const HelpFindModal: React.FC<Props> = ({
  handleCancel,
  initialValues,
  title,
  text
}) => {
  const { handleSubmit, getFieldProps, errors, touched } =
    useFormikContext<typeof initialValues>()
  const { data: translate } = useTranslation()
  return (
    <div className={styles.overlay}>
      <ClickAwayListener onClickAway={handleCancel}>
        <div className={styles.modal}>
          <div className={styles.closeIconWrapper}>
            <Image
              width="17"
              height="17"
              src="/shop/assets/closeIcon.svg"
              className={styles.closeIcon}
              onClick={handleCancel}
            />
          </div>
          <div className={styles.modalTop}>
            <Image width="88" height="22" src="/shop/assets/logo-text.svg" />
            <span className={styles.title}>{title}</span>
            <span className={styles.text}>{text}</span>
          </div>

          <div className={styles.modalForm}>
            <div className={styles.inputDiv}>
              <input
                className={clsx(styles.input, {
                  [styles.inputError]: errors.name && touched.name
                })}
                type="text"
                placeholder={
                  translate?.main.footer['technical-support']['support-name']
                }
                {...getFieldProps('name')}
              />
              {!!errors.name && !!touched.name && (
                <p className={styles.errorText}>{errors.name}</p>
              )}
            </div>
            <div className={styles.inputDiv}>
              <input
                className={clsx(styles.input, {
                  [styles.inputError]: errors.email && touched.email
                })}
                type="text"
                placeholder={
                  translate?.main.footer['technical-support']['support-phone']
                }
                {...getFieldProps('email')}
              />
              {!!errors.email && !!touched.email && (
                <p className={styles.errorText}>{errors.email}</p>
              )}
            </div>

            <div className={styles.textAreaWrapper}>
              <textarea
                className={clsx(styles.input, styles.textarea, {
                  [styles.inputError]: errors.message && touched.message
                })}
                placeholder={translate?.['describe-looking-for'] ?? ''}
                spellCheck="false"
                {...getFieldProps('message')}
              />
              {!!errors.message && !!touched.message && (
                <p className={styles.errorText}>{errors.message}</p>
              )}
            </div>
            <div className={styles.formButtons}>
              <Button
                onClick={handleCancel}
                className={styles.cancelBtn}
                color="primary"
              >
                <span className={styles.cancelBtnText}>
                  {translate?.cancel}
                </span>
              </Button>
              <Button
                onClick={() => handleSubmit()}
                className={styles.submitBtn}
                color="secondary"
              >
                <span className={styles.submitBtnText}>
                  {
                    translate?.main.footer['technical-support'][
                      'support-button'
                    ]
                  }
                </span>
              </Button>
            </div>
          </div>
        </div>
      </ClickAwayListener>
    </div>
  )
}
